/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { POST } from '../../../helpers/httphelper';
import { getDownloadURL, ref, uploadBytesResumable, deleteObject } from 'firebase/storage';
import { storage } from '../../../helpers/Firebase';
import { useNavigate } from "react-router-dom";
import { toast as superToast } from 'bulma-toast'

function MedicinesFormAdd() {
  const UserID = localStorage.getItem('user');
  const [MedicineName, setMedicineName] = useState("")
  const [Dosage, setDosage] = useState("")
  const [Frequency, setFrequency] = useState("")
  const [Morning, setMorning] = useState(false)
  const [MorningTime, setMorningTime] = useState("")
  const [Noon, setNoon] = useState(false)
  const [NoonTime, setNoonTime] = useState("")
  const [Night, setNight] = useState(false)
  const [NightTime, setNightTime] = useState("")
  const [StartDate, setStartDate] = useState("")
  const [EndDate, setEndDate] = useState("")
  const [Channeling, setChanneling] = useState("")
  const [FileUrl, setFileUrl] = useState("")
  const [Description, setDescription] = useState("")
  const [Progress, setProgress] = useState(0)

  const navigate = useNavigate();
  // Set channeling list setter
  const [ChannelingList, setChannelingList] = useState([])

  const fileName = useRef();
  const removebutton = useRef();
  const startDate = useRef();
  const endDate = useRef();

  console.log(UserID)
  useEffect(() => {
    POST("api/channeling/all", { userid: UserID }).then(res => {
      setChannelingList(res)
    }).catch(err => {
      console.log(err)
    })
  }, [])

  useEffect(() => {
    if (!FileUrl) {
      removebutton.current.style.display = "none";
    } else {
      removebutton.current.style.display = "block";
    }
  }, [FileUrl])

  const handlePhotoInput = (e) => {
    e.preventDefault();
    const file = e.target.files[0]; //get file
    console.log(file.name);
    fileName.current.innerText = file.name; //set file name
    fileName.current.style.color = 'black'; //set file name color

    if (!file) { //if no file is selected
      return;
    } else { //if file is selected
      if (FileUrl !== '') { //if file is already selected
        const delRef = ref(storage, FileUrl); //get file reference
        deleteObject(delRef).then(() => { //delete file
          console.log('Photo Deleted from Storage'); //log
          setFileUrl(''); //set file url to empty string
          setProgress(0)  //set progress to 0
        }).catch((err) => { //if error
          console.log(err); //log error
        }); //end delete file
      } //end if file is already selected
      const storageRef = ref(storage, `/medicines/${file.name}`); //get file reference
      const uploadTask = uploadBytesResumable(storageRef, file); //upload file

      uploadTask.on("state_changed", (snapshot) => { //listen for state changes
        const prog = Math.round( //get progress percentage
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100 //calculate progress percentage
        ); //end get progress percentage
        setProgress(prog); //set progress
      }, (err) => {
        console.log(err);
      }, () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setFileUrl(url);
          console.log(url);
        })
      })
    }
  }

  const handlePhotoRemove = () => {
    console.log(FileUrl);
    if (FileUrl !== '') {
      const delRef = ref(storage, FileUrl);
      deleteObject(delRef).then(() => {
        console.log('Photo Deleted from Storage');
        setFileUrl('');
        setProgress(0)
        fileName.current.innerText = 'Enter Medicine Image';
        fileName.current.style.color = 'gray';

      }).catch((err) => {
        console.log(err);
      });
    }

  }
  const addMedicine = (e) => {
    e.preventDefault();
    const data = {
      UserID,
      MedicineName,
      Dosage,
      Frequency,
      Morning,
      MorningTime,
      Noon,
      NoonTime,
      Night,
      NightTime,
      StartDate,
      EndDate,
      Channeling,
      FileUrl,
      Description
    }
    console.log(data);
    POST("api/medicine/add", data).then(res => {
      console.log(res)
      superToast({
        message: 'Medicine Added Successfully',
        type: 'is-success',
        dismissible: true,
        position: "top-center",
        animate: { in: 'fadeIn', out: 'fadeOut' },
      })
      navigate("/medicines")
    }).catch(err => {
      console.log(err)
    }
    )
  }

  return (
    <div>
      <div className='is-justify-content-center is-flex'>
        <h6 className='is-size-1'><b>Add Medicine</b></h6>
      </div>
      <div>
        <div>
          <form onSubmit={addMedicine}>
            <input className="input is-hovered has-background-light mt-3" onChange={(e) => setMedicineName(e.target.value)} type="text" placeholder="Medication Name" required />
            <input className="input is-hovered has-background-light mt-3" onChange={(e) => setDosage(e.target.value)} type="text" placeholder="Dosage example:- 250mg, 25ml, 500mg" required />
            <input className="input is-hovered has-background-light mt-3" onChange={(e) => setFrequency(e.target.value)} type="text" placeholder="Frequency example:- 2 tablet, 1 A teaspoon, 1 A tablespoon" required />
            <div className='is-flex'>
              <div style={{ alignSelf: 'center' }} className='mr-2'>
                <label className="checkbox">
                  <div className='input mt-3 is-fullwidth is-flex has-background-light'>
                    <input type="checkbox" onChange={(e) => setMorning(!Morning)} className='mr-3' />
                    <span style={{ marginRight: '1.7rem' }}>Morning</span>
                  </div>
                </label>
              </div>
              <div style={{ width: '49%' }}>
                <input className="input is-hovered has-background-light mt-3" type="time" onChange={(e) => setMorningTime(e.target.value)} />
              </div>
            </div>
            <div className='is-flex'>
              <div style={{ alignSelf: 'center' }} className='mr-2'>
                <label className="checkbox">
                  <div className='input mt-3 is-fullwidth is-flex has-background-light'>
                    <input type="checkbox" onChange={(e) => setNoon(!Noon)} className='mr-3' />
                    <span className='mr-6'>Noon</span>
                  </div>
                </label>
              </div>
              <div style={{ width: '49%' }}>
                <input className="input is-hovered has-background-light mt-3" type="time" onChange={(e) => setNoonTime(e.target.value)} />
              </div>
            </div>
            <div className='is-flex'>
              <div style={{ alignSelf: 'center' }} className='mr-2'>
                <label className="checkbox">
                  <div className='input mt-3 is-fullwidth is-flex has-background-light'>
                    <input type="checkbox" onChange={(e) => setNight(!Night)} className='mr-3' />
                    <span className='mr-6'>Night</span>
                  </div>
                </label>
              </div>
              <div style={{ width: '49%' }}>
                <input className="input is-hovered has-background-light mt-3" type="time" onChange={(e) => setNightTime(e.target.value)} />
              </div>
            </div>
            <div className='is-justify-content-space-between is-flex'>
              <div style={{ width: '49%' }}>
                <input className="input is-hovered has-background-light mt-3"
                  required
                  ref={startDate}
                  type="text"
                  placeholder='Start Date'
                  onChange={(e) => setStartDate(e.target.value)}
                  onFocus={() => (startDate.current.type = "date")}
                  onBlur={() => (startDate.current.type = "text")}
                />
              </div>
              <div style={{ width: '49%' }}>
                <input className="input is-hovered has-background-light mt-3"
                  ref={endDate}
                  type="text"
                  placeholder='End Date'
                  onChange={(e) => setEndDate(e.target.value)}
                  onFocus={() => (endDate.current.type = "date")}
                  onBlur={() => (endDate.current.type = "text")}
                />
              </div>
            </div>
            <div className="control has-icons-left  mt-3">
              <div className="select is-fullwidth">
                <select onChange={(e) => setChanneling(e.target.value)} className='has-background-light'>
                  <option>Select Channeling Reason</option>
                  {ChannelingList.map((channeling, index) => (
                    <option key={index} value={channeling.reason}>{channeling.reason}</option>
                  ))}
                </select>
              </div>
              <span className="icon is-left">
                <i className="fas fa-globe" />
              </span>
            </div>

            <div className="field has-addons mt-3">
              <div className="control is-expanded">
                <div className="is-fullwidth">
                  <input className="input has-background-light" style={{ display: 'none' }} onChange={(e) => handlePhotoInput(e)} type="file" name="resume" id="imageupload" />
                  <label ref={fileName} htmlFor='imageupload' className="input has-background-light" style={{ color: '#e1e1e1' }}>
                    Image
                  </label>
                  <div className='is-flex is-justify-content-space-between'>
                    <small>Uploaded {Progress}%</small>
                    <button onClick={() => handlePhotoRemove()}
                      ref={removebutton}
                      style={{
                        display: 'none',
                        backgroundColor: '#7BC8FF',
                        fontWeight: '1',
                        color: '#FFFFFF',
                        border: 'none',
                        borderRadius: '8px',
                        alignSelf: 'center',
                      }}
                    >
                      remove
                    </button>
                  </div>
                  <div className="progressText">
                    <progress className="progress is-success" value={Progress} max="100">{Progress}</progress>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>
            <textarea onChange={(e) => setDescription(e.target.value)} className="textarea has-background-light mt-3" placeholder="10 lines of textarea" rows="2"></textarea>
            <div className='is-justify-content-center is-flex'>
              <button type='submit' style={{ backgroundColor: '#7BC8FF', fontWeight: '600', color: '#FFFFFF' }} className='button is-rounded mt-3 pl-6 pr-6 mb-5'> Add </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  )
}

export default MedicinesFormAdd;
